import React, { useEffect, useState } from "react";
import { ROUTES } from "../../utils/Routes";
import Menu from "../../ui/Menu";

export default function ProcessOptions(props) {

    const { controller = "", route = ROUTES.PROCESSING.PROCESS_OPTIONS, item = {}, callback = () => { } } = props;


    const { send_via = "" } = item;

    const [selected, setSelected] = useState({ text: "Prepare order for...", value: 1 });

    const getProcessingOptions = () => {

        const ret = [
            { text: "Prepare order for " + send_via, value: 1 },
            { disabled: true, text: "Prepare & send order", value: 2 },
            { text: "Mark order as 'sent'", value: 3 },
            { disabled: true, text: "View the prepared / sent order", value: 4 },
            { disabled: true, text: "Setup options", value: 5 },
            { disabled: true, text: <>&nbsp;&nbsp;&nbsp;View previous confirmations or orders with PRHW</>, value: 6 },
            { disabled: true, text: <>&nbsp;&nbsp;&nbsp;View any recent orders or confirmations</>, value: 7 },
            { disabled: true, text: <>&nbsp;&nbsp;&nbsp;List / reprocess received EDI documents</>, value: 8 },
            { disabled: true, text: <>&nbsp;&nbsp;&nbsp;List / view outgoing EDI order files</>, value: 9 },
        ]
        return ret;
    }





    // <Menu controller={controller} callback={(e) => setGroup(e.option)} selected={group} setSelected={(e) => setGroup(e)} showCount bordered={true} allow_keys keyName="option" menu={grps} route={route} />


    return (
        <>
            <div className="shim" /><div className="shim" />

            <Menu
                controller={controller}
                route={route}
                callback={(e) => {

                    switch (e?.value || "") {
                        case 1:
                        case 3:
                            callback(e)
                            break;
                        default:
                            break;
                    }
                }}
                use_enter
                keyName="value"
                menu={getProcessingOptions()}
                selected={selected}
                setSelected={setSelected}
            >

            </Menu>
        </>
    )


}